import { useAsyncState } from "./useAsyncState";
export const useAsyncMemo = useAsyncState;
export { createAsyncStateState as createAsyncMemoState } from "./useAsyncState";
//# sourceMappingURL=useAsyncMemo.js.map